import { Grid } from '@material-ui/core';
import React, { useContext } from 'react';
import BaseButton from 'src/common/components/base-button';
import CashierPreferencesHelper from 'src/common/helpers/cashier-preferences-helper';
import { styles } from './age-restiction-styles';
import { IMessageModal } from 'src/common/interfaces/dtos/IMessageModal';
import { EmeraldDialogTypes } from 'src/common/enumerations/emerald-dialog-types';
import { showEmeraldDialog } from 'src/common/components/interactive-dialogue/components/interactive-dialog-content/interactive-dialog-content';
import { useTranslation } from 'react-i18next';
import { ThemeContext } from 'src/emerald-theme-provider';

type Props = IAgeRestrictionActionsProps;

export const showApproveRejectAgeRestrictionDialog = (props: Props): void => {
  showAgeRestrictionModal(props);
};

export const AgeRestrictionButtons = (props): JSX.Element => {
  const { t } = useTranslation();
  const { theme } = useContext(ThemeContext);
  const classes = styles();
  const isLeftHanded = CashierPreferencesHelper.isLeftHanded();
  return (
    <Grid
      container
      className={classes.actionButtonsContainer}
      style={{ direction: theme.direction }}
    >
      <Grid item>
        <BaseButton
          buttonType='white'
          className={classes.cancelButton}
          style={isLeftHanded ? { marginLeft: '1.9vw' } : { marginRight: '1.9vw' }}
          data-testid='age-restriction-cancel-button'
          onClick={props.onClose}
        >
          <span className='label'>{t('Cancel_Button')}</span>
        </BaseButton>
      </Grid>
      <Grid className={classes.approveRejectButtonsContainer}>
        <Grid
          item
          className={
            isLeftHanded ? classes.rejectButtonGridItemInverse : classes.rejectButtonGridItem
          }
        >
          <BaseButton
            className={classes.rejectButton}
            data-testid='age-restriction-reject-button'
            onClick={props.onReject}
          >
            <span className='label'>{t('Reject_Button')}</span>
          </BaseButton>
        </Grid>
        <Grid item>
          <BaseButton
            className={classes.approveButton}
            data-testid='age-restriction-approve-button'
            onClick={props.onApprove}
          >
            <span className='label'>{t('Approve_Button')}</span>
          </BaseButton>
        </Grid>
      </Grid>
    </Grid>
  );
};

const showAgeRestrictionModal = (props: IAgeRestrictionActionsProps): void => {
  const modalConfig: IMessageModal = {
    title: 'AgeRestriction_Title',
    type: EmeraldDialogTypes.Warning,
    message: props.brmCaption || 'AgeRestriction_DefaultMessage',
    subMessage: props.brmMessage || 'AgeRestriction_DefaultSubmessage',
    disableBackdropClick: true,
    acceptButtonLabel: 'AgeRestriction_Approve',
    closeButtonLabel: 'AgeRestriction_Reject',
    buttonComponent: (
      <AgeRestrictionButtons
        onApprove={props.onApprove}
        onReject={props.onReject}
        onClose={props.onClose}
      />
    ),
  };

  showEmeraldDialog(modalConfig);
};

interface IAgeRestrictionActionsProps {
  onClose: () => void;
  onReject: () => void;
  onApprove: () => void;
  brmCaption?: string;
  brmMessage?: string;
}
